import script from "./HezuoHuoban.vue?vue&type=script&setup=true&lang=js"
export * from "./HezuoHuoban.vue?vue&type=script&setup=true&lang=js"

import "./HezuoHuoban.vue?vue&type=style&index=0&id=ee9740e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9740e4"]])

export default __exports__